import { computed, ref, useAttrs } from "vue";

// Mirrors pi-web's useAsyncHandler: tracks async event handlers and exposes
// `processing[event]` after `delay` ms while the returned promise is pending.
export function useAsyncHandler(delay, ...eventNames) {
  const $attrs = useAttrs();

  const attrs = computed(() => ({
    ...$attrs,
    ...Object.fromEntries(
      eventNames.map((name) => [name, (event) => handleEvent(name, $attrs[name], event)]),
    ),
  }));

  const processing = ref(Object.fromEntries(eventNames.map((name) => [name, false])));

  function handleEvent(name, handler, event) {
    if (typeof handler === "function") {
      return doHandleEvent(name, handler(event));
    }
    if (Array.isArray(handler)) {
      return Promise.all(handler.map((h) => handleEvent(name, h, event)));
    }
    return undefined;
  }

  function doHandleEvent(name, result) {
    if (result && typeof result === "object" && typeof result.finally === "function") {
      const timeout = window.setTimeout(() => (processing.value[name] = true), delay);
      return result.finally(() => {
        clearTimeout(timeout);
        processing.value[name] = false;
      });
    }
    return result;
  }

  return { attrs, processing };
}
